import { render, staticRenderFns } from "./TaskComposer.vue?vue&type=template&id=7dac2ba2&scoped=true"
import script from "./TaskComposer.vue?vue&type=script&lang=js"
export * from "./TaskComposer.vue?vue&type=script&lang=js"
import style0 from "./TaskComposer.vue?vue&type=style&index=0&id=7dac2ba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac2ba2",
  null
  
)

export default component.exports